<script>
  import { onMount } from 'svelte';
  import { Bar } from 'svelte-chartjs';
  import { Chart, registerables } from 'chart.js';
  import { API_BASE_URL } from '../components/lib/config.js';
  Chart.register(...registerables);



  //let summary = [];
  let todayWorkStats;
  let monthWorkStats;
  let orderStats;

  let fontSize = 20; // 기본(PC) 크기

  if (typeof window !== 'undefined') {
    fontSize = window.innerWidth <= 768 ? 11 : 20;
    window.addEventListener('resize', () => {
      fontSize = window.innerWidth <= 768 ? 11 : 20;
    });
  }

  async function fetchDashboardData() {
    // 1. Summary
    try {
      const res1 = await fetch(`${API_BASE_URL}/api/orders/summary`);
      //const res1 = await fetch('http://192.168.1.3:5050/api/orders/summary');
      if (!res1.ok) throw new Error('Summary API 오류');
      const data1 = await res1.json();

      const shippedRate = Math.round((data1.monthShipped / data1.monthDue) * 100);
      summary = [
        { label: "당일 접수된 오더", value: `${data1.todayOrders} 건`, diff: "신규 오더" },
        { label: "당월 납기예정", value: `${data1.monthDue} 건`, diff: "토탈 오더" },
        { label: `납기임박 : ${data1.dueSoon} 건`, value: `${data1.dueSoon} 건`, diff: `당일납기 : ${data1.dueSoon} 건` },
        { label: "당월 출하비율", value: `${shippedRate} %`, diff: `${data1.monthShipped}/${data1.monthDue}` }
      ];

    } catch (err) {
      console.error('Summary fetch 실패:', err);
    }


    // 2. Work Stats    
    const res2 = await fetch(`${API_BASE_URL}/api/orders/workstats`);
    //const res2 = await fetch('http://192.168.1.3:5050/api/orders/workstats');
    const data2 = await res2.json();
    const labels = [
      '자재준비 완료', '가공시작', '가공종료',
      '추가가공 시작', '추가가공 종료',
      '후처리시작', '후처리종료', '출하'
    ];
    const keys = [
      'material_ready', 'process_start', 'process_end',
      'add_process_start', 'add_process_end',
      'post_process_start', 'post_process_end', 'shipment'
    ];
    todayWorkStats = {
      labels,
      datasets: [{
        label: '건수',
        data: keys.map(k => data2.today[k]),
        backgroundColor: colors
      }]
    };
    monthWorkStats = {
      labels,
      datasets: [{
        label: '건수',
        data: keys.map(k => data2.month[k]),
        backgroundColor: colors
      }]
    };

    // 3. Client Stats
    const res3 = await fetch(`${API_BASE_URL}/api/orders/clientstats`);
    //const res3 = await fetch('http://192.168.1.3:5050/api/orders/clientstats');
    const data3 = await res3.json();
    // 이번달에 주문이 있는 경우만 로드 
    // orderStats = {
    //   labels: data3.monthly.map(d => d.client_name),
    //   datasets: [
    //     {
    //       label: '월별 주문량',
    //       data: data3.monthly.map(d => d.count),
    //       backgroundColor: 'rgba(54, 162, 235, 0.7)'
    //     },
    //     {
    //       label: '누적 주문량',
    //       data: data3.total.map(d => d.count),
    //       backgroundColor: 'rgba(255, 206, 86, 0.7)'
    //     }
    //   ]
    // };

    // 이번달에 주문이 없어도 로드
    orderStats = {
      labels: data3.labels,
      datasets: [
        {
          label: '월별 주문량',
          data: data3.monthly,
          backgroundColor: '#7e57c2' // 진한 보라색
        },
        {
          label: '누적 주문량',
          data: data3.total,
          backgroundColor: '#fb8c00' // 선명한 오렌지색
        }
      ]
    };
  }

  onMount(() => {
    fetchDashboardData(); // 최초 실행
    const interval = setInterval(fetchDashboardData, 5 * 60 * 1000); // 5분마다 실행

    return () => clearInterval(interval); // 컴포넌트 언마운트 시 정리
  });

  let summary = [    
    { label: "당일 접수된 오더", value: 0, diff: "신규 오더" },
    { label: "당월 납기예정", value: 0, diff: "토탈 오더" },
    { label: "납기임박 : 0ea", value: 0, diff: "당일납기 : 20ea" },
    { label: "당월출하비율 : 0ea", value: 0, diff: "당일납기 : 20ea" },
  ];


  let machineStatus = [
    { name: "Machine 1", status: "done", detail: "Processing end 05:20" },
    { name: "Machine 2", status: "running", detail: "No errors" },
    { name: "Machine 3", status: "running" },
    { name: "Machine 4", status: "running" },
    { name: "Machine 5", status: "stopped", detail: "E101" },
    { name: "Machine 6", status: "done", detail: "Processing end 06:10" },
    { name: "Machine 7", status: "running" },
    { name: "Machine 8", status: "running" },
    { name: "Machine 9", status: "running" },
    { name: "Machine 10", status: "stopped", detail: "E202" }
  ];

  let issues = [
    { time: "10:05", message: "Material shortage on Machine 2" },
    { time: "10:27", message: "Post-processing error on Machine 5" }
  ];

  let equipmentStatus = [
    { name: "Drill A", status: "Running", last: "2024-07-20" },
    { name: "Finisher B", status: "Stopped", last: "2024-07-15" }
  ];



  // 색상 팔레트
  const colors = [
    '#e53935', // 자재준비 완료 (강렬한 빨강)
    '#1e88e5', // 가공시작 (선명한 파랑)
    '#fdd835', // 가공종료 (노랑)
    '#43a047', // 추가가공 시작 (초록)
    '#8e24aa', // 추가가공 종료 (보라)
    '#fb8c00', // 후처리시작 (오렌지)
    '#757575', // 후처리종료 (회색)
    '#00c853'  // 출하 (강한 초록)
  ];
</script>




<main>
  <div class="dashboard">
  <!-- Summary Cards -->
  <div class="summary">
    {#each summary as s, i}
      <div class="card">
        <!-- 카드 헤더 + 아이콘 -->
        <div class="card-header">
          {#if i === 0}
            <i class="fas fa-plus-circle"></i> 당일 신규오더
          {:else if i === 1}
            <i class="fas fa-calendar-alt"></i> 당월 납기 오더
          {:else if i === 2}
            <i class="fas fa-exclamation-triangle"></i> 납기임박 건수
          {:else if i === 3}
            <i class="fas fa-chart-line"></i> 당월 출하비율
          {/if}
        </div>

        <!-- 카드 내용 -->
        <div class="value">{s.value}</div>
        <div>{s.label}</div>
        {#if s.diff}<div style="color: red;">{s.diff}</div>{/if}
      </div>
    {/each}
  </div>





    <!-- Work Stats Charts -->
    <div class="work-charts">

      <div class="work-card">
        <div class="card-header">당일 작업내역</div>
        <Bar 
          data={todayWorkStats} 
          options={{
            indexAxis: 'y',
            responsive: true,
            plugins: {
              legend: { display: false },
              title: { display: false }
            },
            scales: {
              x: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1,         // ✅ 눈금 간격 1
                  precision: 0,        // ✅ 소수점 제거
                  font: { size: fontSize }  // 반응형 폰트 크기 적용
                },
                suggestedMax: 5
              },
              y: {
                ticks: {
                  font: { size: fontSize }  // 반응형 폰트 크기 적용
                }
              }
            }
          }}
        />
      </div>

      <div class="work-card">
        <div class="card-header">당월 작업내역</div>
        <Bar 
          data={monthWorkStats} 
          options={{ 
            indexAxis: 'y',
            responsive: true,
            plugins: {
              legend: { display: false }, // ✅ 범례 제거
              title: { display: false }   // ✅ 제목 제거
            },
            scales: {
              x: {
                beginAtZero: true,
                ticks: {
                  stepSize: 1,              // 눈금 간격 1
                  precision: 0,             // 소수점 제거
                  font: { size: fontSize }  // 반응형 폰트 크기 적용
                },
                suggestedMax: 5
              },
              y: {
                ticks: {
                  font: { size: fontSize }  // 반응형 폰트 크기 적용
                }
              }
            }
          }} 
        />
      </div>




    </div>

    <!-- Bar Chart: 발주처 주문통계 -->
    <div class="chart-box">
      <!-- <h3>발주처 주문통계</h3> -->
      <div class="card-header">발주처 주문통계</div>
      <Bar
        data={orderStats}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true, // ✅ 범례 표시
              position: 'top', // 범례 위치 (top, bottom, left, right 가능)
              labels: {
                font: { size: fontSize },  // 반응형 폰트 크기 적용
                color: '#333'
              }
            },
            title: { display: false }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                font: { size: fontSize }  // 반응형 폰트 크기 적용
              }                          
            },
            x: {
              ticks: {
                autoSkip: false,
                padding: 10,
                font: {
                  font: { size: fontSize }  // 반응형 폰트 크기 적용
                }
              }
            }
          },
          layout: {
            padding: {
              bottom: 40
            }
          }
        }}
      />
    </div>

    <!-- Machine Status -->
    <!-- <div class="machines">
      {#each machineStatus as m}
        <div class="machine-card {m.status}">
          <h4>{m.name}</h4>
          <p>{m.status === 'done' ? 'Done' : m.status === 'running' ? 'Running' : 'Stopped'}</p>
          {#if m.detail}<small>{m.detail}</small>{/if}
        </div>
      {/each}
    </div> -->

    <!-- Issues -->
    <!-- <div class="issues">
      <h3>당일 이슈</h3>
      <ul>
        {#each issues as i}
          <li>{i.time} - {i.message}</li>
        {/each}
      </ul>
    </div> -->

    <!-- Equipment Status -->
    <!-- <div class="equipment">
      <h3>장비현황</h3>
      <table>
        <thead>
          <tr><th>Equipment</th><th>Status</th><th>Last Service</th></tr>
        </thead>
        <tbody>
          {#each equipmentStatus as e}
            <tr>
              <td>{e.name}</td>
              <td style="color: {e.status === 'Running' ? 'lightgreen' : 'red'}">{e.status}</td>
              <td>{e.machineStatuslast}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div> -->
  </div>
</main>



<style>

  .dashboard {
    width: 100%;
    margin: 0 auto;             /* 가운데 정렬 */
    display: grid;
    gap: 1.5rem;
    padding: 2rem;
    background-color: #ffffff;
    color: #0f0f0f;
    font-family: sans-serif;
    box-sizing: border-box;
    
  }


  .summary {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;    
    font-size: 1rem;
  }
  .card {
    border: 1px solid #cfcfca;
    background-color: #fcfcf8;
    padding: 1rem;
    border-radius: 12px;    
    text-align: center;
    border-left: 8px solid #ffa000;
  }
  .card-header {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 1.6em;
    margin-bottom: 8px;
    color: #c300ff;
  }


  .card .value {
    font-size: 3rem;
    font-weight: bold;
  } 
  .work-charts {
    display: grid; /* flex에서 grid로 변경 */
    grid-template-columns: repeat(2, 1fr); /* 기본적으로 2개의 컬럼 */
    gap: 1rem;
  }
  .work-card {
    flex: 1;
    border: 1px solid #cfcfca;
    background-color: #fcfcf8;    
    padding: 1rem;
    border-radius: 12px;
    border-left: 8px solid #ffa000;
  }
  .charts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 2rem;
  }
  .chart-box {
    position: relative;       /* ✅ Chart.js가 크기 계산 가능하게 함 */

    border: 1px solid #cfcfca;
    background-color: #fcfcf8;
    padding: 1rem;
    border-radius: 12px;
    /* 차트가 무한히 늘어나지 않도록 최대 높이를 설정 */
    max-height: 500px; /* 원하는 높이로 조절하세요 */
    /* 컨테이너를 벗어나는 내용은 숨깁니다 */
    overflow: hidden;
    border-left: 8px solid #ffa000;
  }
  
  .machines {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* ✅ 한 줄에 5개 고정 */
    gap: 1rem;
  }

  .machine-card {
    border: 1px solid #cfcfca;
    background-color: #fcfcf8;
    padding: 1rem;
    border-radius: 10px;
    text-align: center;
  }
  .machine-card.running { border-left: 5px solid #00c853; }
  .machine-card.done { border-left: 5px solid #29b6f6; }
  .machine-card.stopped { border-left: 5px solid #d32f2f; }
  .issues, .equipment {
    border: 1px solid #cfcfca;
    background-color: #fcfcf8;
    padding: 1rem;
    border-radius: 10px;
  }
  /* 화면 너비가 768px 이하일 때 1개 컬럼으로 변경 */
  @media (max-width: 768px) {
    .dashboard {
      padding: 1rem;           /* 좌우 여백 균형 */
    } 
    .work-charts {
      grid-template-columns: 1fr;
    }
    .summary,
    .work-charts,
    .work-card,
    .chart-box {
      max-width: 95%;    /* 좌우에 여백 유지 */
    }
  }
  @media (max-width: 430px) {
    .summary,
    .work-charts,
    .work-card,
    .chart-box {
      max-width: 98%;    /* 좌우에 여백 유지 */
    }
  }

</style>